module.exports = __webpack_public_path__ + "img/referral_2.3b3d3817.jpeg";